import SignaturePad from "signature_pad";
import angular from "angular";
import loadSignature from "./loadSignature";

angular
  .module("ticketco/ticketbuyer/signature")
  .directive("tcSignature", tcSignature);

function tcSignature() {
  return {
    template:
      "<canvas width='384' height='224' class='block w-96 h-56 border-2 border-sageGreen-60 rounded-main' />",
    scope: {
      signature: "<",
      onChange: "&",
    },

    link: function (scope, element, attrs) {
      $("body").attr("onselectstart", "return false");
      var canvas = $(element).find("canvas")[0];

      loadSignature().then((SignaturePad) => {
        var signaturePad = new SignaturePad(canvas, {
          onEnd: function () {
            scope.$apply(function () {
              scope.onChange({
                $image: signaturePad.toDataURL("image/svg+xml"),
              });
              scope.image = signaturePad.toDataURL("image/svg+xml");
            });
          },
        });

        var resizeCanvas = (this.resizeCanvas = function () {
          var ratio = Math.max(window.devicePixelRatio || 1, 1);

          // This part causes the canvas to be cleared
          canvas.width =
            (canvas.offsetWidth || document.body.clientWidth) * ratio;
          canvas.height =
            (canvas.offsetHeight || document.body.clientWidth * 0.35) * ratio;
          canvas.getContext("2d").scale(ratio, ratio);
          signaturePad.clear();
        });

        resizeCanvas();
      });
    },
  };
}
